<template>
  <div class="wrap" v-if="isShow" >
    <div v-if="isShow" @click="clickIndex">
      <div class="correlation-index">
        <div class="index-desc">
        <span>关联指数 | {{pageData.INDEXNAME}}</span>
        </div>
        <div class="detail-view">
          <div class="index-desc-de">详情</div>
          <img src="@/assets/right-arrow-gray.png"
          alt=""
          class="right-arrow"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JS from '@/base/JSTool';
import StoreManger from '@/utils/FundHQJHManger';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'WarningwTip',
  props: {},
  watch: {},
  data() {
    return {
      isShow: false,
      isShowGJ: true,
      pageData: {},
      fundCode: '',
      fundType: '',
      indexZDZ: '--',
      indexValue: '',
      indexZDF: '--',
    };
  },
  computed: {},
  created() {
    this.render(false);
  },
  mounted() {},
  methods: {
    render(iscache) {
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
      this.handleData(StoreManger.getFundJJXQ(), iscache);
    },
    show() {
      const { INDEXNAME, LINKZSB } = this.pageData;

      let res = false;
      if (!INDEXNAME || INDEXNAME === '--') {
        res = false;
      } else {
        res = true;
      }
      if (!LINKZSB || LINKZSB === '--') {
        res = false;
      }
      if (LINKZSB === '1') {
        res = true;
      }
      this.isShow = res;
    },
    format(item) {
      const fetch = (key) => {
        const res = JS.fetchString(item, key);
        return res || '--';
      };
      let INDEXINFO = {};
      if (item) {
        if (item.Expansion) {
          if (item.Expansion.INDEXINFO) {
            INDEXINFO = item.Expansion.INDEXINFO;
          }
        }
      }
      let gzpj = '';
      let firstTip = '低于';
      if (INDEXINFO.INDEXVALUA) {
        if (INDEXINFO.INDEXVALUA === '-1') {
          gzpj = '较为低估';
        } else if (INDEXINFO.INDEXVALUA === '-2') {
          gzpj = '低估';
        } else if (INDEXINFO.INDEXVALUA === '0') {
          gzpj = '适中';
        } else if (INDEXINFO.INDEXVALUA === '1') {
          gzpj = '较为高估';
          firstTip = '高于';
        } else if (INDEXINFO.INDEXVALUA === '2') {
          gzpj = '高估';
          firstTip = '高于';
        }
      }
      let gzpjms = '';
      if (INDEXINFO.ISUSEPBP) {
        if (INDEXINFO.ISUSEPBP === '1') {
          if (firstTip === '高于') {
            gzpjms = `${firstTip}历史${(parseFloat(INDEXINFO.PBP100)).toFixed(2)}%的市净率`;
          } else {
            gzpjms = `${firstTip}历史${(100 - parseFloat(INDEXINFO.PBP100)).toFixed(2)}%的市净率`;
          }
        } else if (INDEXINFO.ISUSEPBP === '0') {
          if (firstTip === '高于') {
            gzpjms = `${firstTip}历史${(parseFloat(INDEXINFO.PEP100)).toFixed(2)}%的市盈率`;
          } else {
            gzpjms = `${firstTip}历史${(100 - parseFloat(INDEXINFO.PEP100)).toFixed(2)}%的市盈率`;
          }
        }
      }
      return {
        INDEXCODE: fetch('INDEXCODE'),
        NEWINDEXTEXCH: fetch('NEWINDEXTEXCH'),
        INDEXNAME: fetch('INDEXNAME'),
        LINKZSB: fetch('LINKZSB'),
        gzpj,
        gzpjms,
        INDEXINFO,
      };
    },
    handleDefault() {
      this.handleData(null, false);
    },
    handleData(item) {
      this.pageData = this.format(item);
      this.show();
      if (this.pageData.INDEXINFO) {
        const { INDEXVALUA, ISUSEPBP } = this.pageData.INDEXINFO;
        if (INDEXVALUA && INDEXVALUA !== '--') {
          if (ISUSEPBP === '0' || ISUSEPBP === '1') {
            this.isShowGJ = true;
            return;
          }
        }
      }
      this.isShowGJ = false;
      // this.request(iscache);
    },
    async request(iscache) {
      const indexC = `${this.pageData.NEWINDEXTEXCH}.${this.pageData.INDEXCODE}`;
      if (!iscache) {
        await this.$store.dispatch('updateStokeCodelist', indexC);
      }
      if (this.$store.state.emhq.fund[indexC].data) {
        const datas = this.$store.state.emhq.fund[indexC].data.diff;
        if (datas.length > 0) {
          const indexData = datas[0];
          const { f2, f3 } = indexData;
          this.indexZDF = f3 ? `${parseFloat(f3).toFixed(2)}%` : '--';
          this.indexValue = f3;
          this.indexZDZ = parseFloat(f2).toFixed(2);
        }
      }
    },
    upDown(value) {
      if (value === '--') {
        return 'gray';
      }
      const newV = parseFloat(value);
      if (newV > 0) {
        return 'red';
      }
      if (newV < 0) {
        return 'green';
      }
      return 'gray';
    },
    clickIndex() {
      // 跳转
      detailPushPage({
        type: 2,
        url: `fund://mp.1234567.com.cn/weex/7d7b3460cd40444ba58cdabdfae34442/pages/indexDetailInfoPage?indexCode=${this.pageData.INDEXCODE}`,
      });
      this.reportMonitor({
        eventName: 'pz.top.index',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
    showTips() {},
    showFundType() {},
  },
};
</script>

<style lang="less" scoped>
.wrap{
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 20px;
  height: 94px;
}
.correlation-index {
  background: #fff;
  display: flex;
  height: 88px;
  padding-left: 24px;
  padding-right: 14px;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
}

.index-desc {
  font-family: PingFang-SC-Regular;
  font-size: 30px;
  color: #000;
  letter-spacing: 0;
  text-align: left;
  line-height: 35px;
  margin-right: 24px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}

.index-desc-de {
  font-family: PingFang-SC-Regular;
  font-size: 28px;
  width: 60px;
  color: #999999;
}
.detail-view{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.right-arrow {
    width: 32px;
    height: 32px;
}
</style>
